export const COOKIE_CONSENT_VERSION = 2;
export const COOKIE_CONSENT_STORAGE_KEY = "missionMovementCookieConsentV2";
export const COOKIE_SETTINGS_EVENT = "openCookieSettings";
export const COOKIE_CONSENT_UPDATED_EVENT = "cookieConsentUpdated";

export const defaultCookieConsent = {
  necessary: true,
  analytics: false,
  marketing: false,
  acceptedAt: "",
  version: COOKIE_CONSENT_VERSION,
};

const canUseStorage = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

const normalizeConsent = (value) => {
  if (!value || value.version !== COOKIE_CONSENT_VERSION) return null;

  return {
    necessary: true,
    analytics: value.analytics === true,
    marketing: value.marketing === true,
    acceptedAt: value.acceptedAt || "",
    version: COOKIE_CONSENT_VERSION,
  };
};

export const getCookieConsent = () => {
  if (!canUseStorage()) return null;

  try {
    return normalizeConsent(
      JSON.parse(window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)),
    );
  } catch {
    return null;
  }
};

export const setCookieConsent = ({
  analytics = false,
  marketing = false,
} = {}) => {
  const consent = {
    necessary: true,
    analytics: analytics === true,
    marketing: marketing === true,
    acceptedAt: new Date().toISOString(),
    version: COOKIE_CONSENT_VERSION,
  };

  if (!canUseStorage()) return consent;

  try {
    window.localStorage.setItem(
      COOKIE_CONSENT_STORAGE_KEY,
      JSON.stringify(consent),
    );
  } catch {
    // Keep the UI usable when storage is unavailable.
  }

  window.dispatchEvent(
    new CustomEvent(COOKIE_CONSENT_UPDATED_EVENT, { detail: consent }),
  );

  return consent;
};

export const hasAnalyticsConsent = () => getCookieConsent()?.analytics === true;

export const hasMarketingConsent = () => getCookieConsent()?.marketing === true;

export const openCookieSettings = () => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
};
